import React, { useEffect, useState } from 'react'
import './updatecash.css'
import { API_URL } from '../../Config';


function UpdateCash() {
    const [cashData, setCashData] = useState({ amount: 0, limit1: 0, limit2: 0 });
    useEffect(() => {
        fetch(`${API_URL}/cashdata`)
          .then(res => res.json())
          .then(data => {
            setCashData(data[0]);
          })
          .catch(err => console.log(err));
      }, []);

    const [cashUpdate, setCashUpdate] = useState({});
      const handleUpdate = () => {
        const updateData = {};
        if (cashUpdate.amount !== "") {
          updateData.amount = cashUpdate.amount;
        }
        if (cashUpdate.limit1 !== "") {
          updateData.limit1 = cashUpdate.limit1;
        }
        if (cashUpdate.limit2 !== "") {
          updateData.limit2 = cashUpdate.limit2;
        }
        fetch(`${API_URL}/update/cash`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(updateData)
        })
          .then(res => res.json())
          .then(data => {
            setCashData({...cashData, ...updateData});
            setCashUpdate({});
            fetch(`${API_URL}/cashdata`)
            .then(res => res.json())
            .then(data => setCashData(data[0]))
            .catch(err => console.log(err));        
          })
          .catch(err => console.log(err));
      };

  return (
    <div className='new-data'>
        <div className="home-cash-limit">
          <div className="home-cash">
            <p>Total cash:</p>
            <p>{cashData.amount}</p>
          </div>
          <div className="home-cash">
            <p>Account1 limit:</p>
            <p>{cashData.limit1}</p>
          </div>
          <div className="home-cash">
            <p>Account2 limit:</p>
            <p>{cashData.limit2}</p>
          </div>
        </div>
        <div className="new-data-container">
            <h2>Update cash and Limit</h2>
            <div className="transaction-form">
                <input placeholder='Total Cash' type="text" value={cashUpdate.amount || ""} onChange={e => setCashUpdate({...cashUpdate, amount: e.target.value})} />
                <input placeholder='Limit of 1st account...' type="text" value={cashUpdate.limit1 || ""} onChange={e => setCashUpdate({...cashUpdate, limit1: e.target.value})} />
                <input placeholder='Limit of 2nd account...' type="text" value={cashUpdate.limit2 || ""} onChange={e => setCashUpdate({...cashUpdate, limit2: e.target.value})} />
                <button onClick={handleUpdate}>Update</button>
            </div>
        </div>
    </div>
  )
}

export default UpdateCash
